var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstallation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#a9d0e0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.15,77.37l-2.92-.97h-14.81c-.78,0-1.41-.63-1.41-1.41v-3.39c0-.78.63-1.41,1.41-1.41h14.81l2.92-.98c.39-.17.83.11.83.54v7.08c0,.43-.44.71-.83.54Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.23,71.8h2.49c.45,0,.82.37.82.82v2.16h-4.13v-2.16c0-.45.37-.82.82-.82Z",
    transform: "translate(129.76 16.82) rotate(90)",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.96,71.94h19.03c.09,0,.17.03.24.09l1.13.91c.22.18.22.54,0,.71l-1.13.91c-.07.06-.15.09-.24.09h-19.03",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.53,59.1l-32.15-.13c-.54,0-1.06.25-1.41.67l-1.3,1.6c-.37.45-.91.7-1.48.7h-2.86c-.44,0-.86-.15-1.2-.42l-2.67-2.15c-.23-.18-.1-.55.2-.55h4.01c.67,0,1.22-.54,1.22-1.22v-1.76c0-.67-.55-1.21-1.22-1.22h-4.02c-.29,0-.42-.37-.19-.55l2.66-2.15c.34-.27.77-.42,1.2-.42h2.86c.58,0,1.12.26,1.48.7l1.31,1.6c.34.43.86.67,1.4.67l32.15.13",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.09,42.86h49.47c1.56,0,2.82,1.26,2.82,2.82v34.96c0,1.56-1.26,2.82-2.82,2.82h-49.47c-1.56,0-2.82-1.26-2.82-2.82v-34.96c0-1.56,1.26-2.82,2.82-2.82Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.34,42.86v-9.83c0-1.57,1.27-2.84,2.84-2.84h33.07c1.57,0,2.84,1.27,2.84,2.84v9.83",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.41,42.86v-8.32c0-.51.41-.93.93-.93h28.95c.51,0,.93.41.93.93v8.32",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 42.86,
    width: 8.46,
    height: 3.51,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.88,
    y: 42.86,
    width: 8.46,
    height: 3.51,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.9cbf826e1bde6171bd96760f6c805a33.svg";
export { ForwardRef as ReactComponent };